import { ChromeDrawer } from "#webapp/src/components/chrome-drawer";
import { ChromeFeedback } from "#webapp/src/components/chrome-feedback";
import { LogoutBtn } from "#webapp/src/components/logout-btn";
import { TrackingEvents } from "#webapp/src/util/analytics.util";
import { baseUrl as helpCenterUrl } from "@clockwise/client-commons/src/constants/help-center";
import { ExitToApp, Help } from "@clockwise/design-system/icons";
import { useTracking } from "@clockwise/web-commons/src/util/analytics.util";
import React, { useMemo } from "react";
import { ChromeMenuHeader } from "../chrome-menu-drawer/ChromeMenuHeader";
import { ChromeMenuItem } from "../chrome-menu-drawer/ChromeMenuItem";

interface Person {
  email: string;
  givenName?: string | null;
  familyName?: string | null;
  externalImageUrl?: string | null;
}

export interface IProps {
  open: boolean;
  onClose: () => void;
  person: Person;
}

//////////////////
// COMPONENT
//////////////////
export const MenuDrawer = ({ onClose, person, open }: IProps) => {
  const track = useTracking();

  // ChromeMenuHeader expects a person object based on old webserver schema
  const avatarCompatiblePerson = useMemo(
    () => ({
      primaryEmail: person.email,
      profile: {
        givenName: person.givenName,
        familyName: person.familyName,
        externalImageUrl: person.externalImageUrl,
      },
    }),
    [person],
  );

  return (
    <ChromeDrawer open={open}>
      <ChromeMenuHeader person={avatarCompatiblePerson} email={person.email} onClose={onClose} />
      <div className="cw-overflow-y-scroll">
        <ChromeFeedback />
        <ChromeMenuItem
          label="Help center"
          onClick={() => {
            track(TrackingEvents.CHROME_MENU.CLICK_HELP);
            window.open(helpCenterUrl, "_blank");
          }}
          IconComponent={Help}
        />
        <LogoutBtn
          isMenuItem
          menuItemIcon={<ExitToApp className="cw-text-muted" />}
          onLogout={() => {
            track(TrackingEvents.CHROME_MENU.CLICK_LOGOUT);
            onClose();
          }}
        />
      </div>
    </ChromeDrawer>
  );
};
